module.exports = __webpack_public_path__ + "img/close-red-round.ff8f0f79.svg";